<template>
  <div v-if="data" class="row-box">
    <!-- Срок, когда обязательство должно было быть исполнено (дата или условие): start -->
    <TitleField
      v-if="orDateCondition"
      :fieldName="'isOrDateCondition'"
      :fieldGroup="'executiveNoticesRecoveryDetails'"
    />
    <WrapperField
      v-for="(value, index) in orDateCondition"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: 'executiveNoticesRecoveryDetails',
        })
      "
    ></WrapperField>
    <!-- Срок, когда обязательство должно было быть исполнено (дата или условие): end -->

    <!-- Срок, за который производится взыскание: start -->
    <TitleField
      v-if="isTermCollectionTitle"
      :fieldName="'isTermCollectionTitle'"
      :fieldGroup="'executiveNoticesRecoveryDetails'"
    />
    <WrapperField
      v-for="(value, index) in termCollection"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: 'executiveNoticesRecoveryDetails',
        })
      "
    ></WrapperField>
    <!-- Срок, за который производится взыскание: end -->

    <!-- Сумма: start -->
    <TitleField
      v-if="amount"
      :fieldName="'isAmount'"
      :fieldGroup="'executiveNoticesRecoveryDetails'"
    />
    <WrapperField
      v-for="(value, index) in amount"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: converterFromPennyToRub(value),
          fieldGroup: 'executiveNoticesRecoveryDetails',
        })
      "
    ></WrapperField>
    <!-- Сумма: end -->

    <!-- Сведения о подлежащем истребованию имуществе и его идентифицирующих признаках: start -->
    <TitleField
      v-if="demandOwnDetails"
      :fieldName="'isDemandOwnDetails'"
      :fieldGroup="'executiveNoticesRecoveryDetails'"
    />
    <WrapperField
      v-for="(value, index) in demandOwnDetails"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: 'executiveNoticesRecoveryDetails',
        })
      "
    ></WrapperField>
    <!-- Сведения о подлежащем истребованию имуществе и его идентифицирующих признаках: end -->

    <!-- Реквизиты взыскателя для получения денежных средств: start -->
    <TitleField
      v-if="judgementCreditorBankDetails"
      :fieldName="'isJudgementCreditorBankDetails'"
      :fieldGroup="'judgementCreditorBankDetails'"
    />
    <WrapperField
      v-for="(value, index) in judgementCreditorBankDetails"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: 'judgementCreditorBankDetails',
        })
      "
    ></WrapperField>
    <!-- Реквизиты взыскателя для получения денежных средств: end -->
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import { converterFromPennyToRub } from '@/utils/common';

export default {
  name: 'Step6',
  components: {
    WrapperField,
    TitleField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
    converterFromPennyToRub,
  }),
  computed: {
    orDateCondition() {
      return this.data
        ? {
            timeLimitDate: this.data.timeLimitDate,
            timeLimitCondition: this.data.timeLimitCondition,
          }
        : {};
    },
    demandOwnDetails() {
      return this.data && this.data.demandOwn
        ? {
            demandOwn: this.data.demandOwn,
          }
        : null;
    },
    judgementCreditorBankDetails() {
      return this.data && this.data.judgementCreditorBankDetails
        ? {
            jdgmntCreditorName: this.data.jdgmntCreditorName,
            // меняем положение наименование банка
            bankName: this.data.judgementCreditorBankDetails.bankName,
            ...this.data.judgementCreditorBankDetails,
          }
        : {};
    },
    amount() {
      return this.data
        ? {
            penaltySum: this.data.penaltySum,
            penaltyDebt: this.data.penaltyDebt,
            penaltyPercent: this.data.penaltyPercent,
            penaltyForfeit: this.data.penaltyForfeit,
            penaltyCosts: this.data.penaltyCosts,
          }
        : {};
    },
    termCollection() {
      const obj = {};
      if (!this.data) return {};
      if (this.data.penaltyLimFrom)
        obj.penaltyLimFrom = this.data.penaltyLimFrom;
      if (this.data.penaltyLimTo) obj.penaltyLimTo = this.data.penaltyLimTo;
      return obj;
    },
    isTermCollectionTitle() {
      return (
        Boolean(this.termCollection.penaltyLimFrom) ||
        Boolean(this.termCollection.penaltyLimTo)
      );
    },
  },
  methods: {
    translateKop(value) {
      let sum = value / 100 + '';
      sum = sum.split('.');
      return sum[1] ? `${sum[0]},${sum[1]}` : `${sum[0]}`;
    },
  },
};
</script>
